import { Network } from '@aptos-labs/ts-sdk';
import {
  APTOS_MAINNET_API_KEY,
  getAptosAuthHeaders,
} from '@aries/shared/utils';

export type AptosNodeMeta = {
  name: string;
  desc: string;
  nodeUrl: string;
  pingUrl: string;
  faucetUrl: string;
  network: Network;
  apiKey?: string;
  headers?: Record<string, string>;
};

export const MAINNET_APTOS_API_NODE_NAME = 'Mainnet - Aptos API';
export const MAINNET_OFFICIAL_NODE_NAME = 'Mainnet - Official Node';

export const APTOS_NODE_LIST: AptosNodeMeta[] = [
  {
    name: MAINNET_APTOS_API_NODE_NAME,
    desc: 'Aptos Mainnet.',
    nodeUrl: 'https://api.mainnet.aptoslabs.com/v1',
    pingUrl: 'https://api.mainnet.aptoslabs.com/v1',
    faucetUrl: '-',
    network: Network.MAINNET,
    apiKey: APTOS_MAINNET_API_KEY,
  },
  {
    name: 'Mainnet - Alchemy',
    desc: 'Aptos Mainnet.',
    nodeUrl:
      'https://aptos-mainnet.g.alchemy.com/v2/ZKwtk-kKKL8hgqXiY37lm/v1',
    pingUrl:
      'https://aptos-mainnet.g.alchemy.com/v2/ZKwtk-kKKL8hgqXiY37lm/v1',
    faucetUrl: '-',
    network: Network.MAINNET,
  },
  {
    name: MAINNET_OFFICIAL_NODE_NAME,
    desc: 'Aptos Mainnet.',
    nodeUrl: 'https://fullnode.mainnet.aptoslabs.com/v1',
    pingUrl: 'https://fullnode.mainnet.aptoslabs.com/v1',
    faucetUrl: '-',
    network: Network.MAINNET,
  },
  {
    name: 'Mainnet - QuickNode',
    desc: 'Aptos Mainnet.',
    nodeUrl:
      'https://muddy-wispy-pond.aptos-mainnet.quiknode.pro/60b2999c0573845e7f1cc448fc22739ed03003b6/v1',
    pingUrl:
      'https://muddy-wispy-pond.aptos-mainnet.quiknode.pro/60b2999c0573845e7f1cc448fc22739ed03003b6/v1',
    faucetUrl: '-',
    network: Network.MAINNET,
  },
  {
    name: 'Testnet - NodeReal',
    desc: 'Aptos Testnet.',
    nodeUrl:
      'https://aptos-testnet.nodereal.io/v1/98ef20c983004209b66b8ed5eb6bb8a4/v1',
    pingUrl:
      'https://aptos-testnet.nodereal.io/v1/98ef20c983004209b66b8ed5eb6bb8a4/v1',
    faucetUrl: '-',
    network: Network.TESTNET,
  },
];

export const getAptosNodeRequestHeaders = (
  node: Pick<AptosNodeMeta, 'apiKey' | 'headers'>,
) => getAptosAuthHeaders(node.apiKey, node.headers);
